export enum ADMIN_TAGS_TYPE {
    normal = 'normal',
    education = 'education',
    personalized = 'personalized',
}export enum ADMIN_TAGS_TYPE {
    normal = 'normal',
    education = 'education',
    personalized = 'personalized',
}